import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import gsap from 'gsap';

const posts = [
    {
        id: 'agent-ready-build-in-public',
        title: "From 0/100 to Level 5 Agent-Native in One Sunday",
        excerpt: "A live log of the agentic commerce work we shipped on May 17, 2026. JSON-LD schema, ACP discovery, MPP OpenAPI, A2A Agent Card, AP2 declaration, real Stripe Checkout for AI agents. Scored with isitagentready.com.",
        image: "/images/blog/agent-ready-scorecard-2026-05-17.png",
        date: "May 17, 2026",
        readTime: "9 MIN",
        path: "/blog/agent-ready-build-in-public"
    },
    {
        id: 'vito-phone-line-livestream-build',
        title: "We Gave an AI Agent a Real Phone Number — Live on Camera",
        excerpt: "In under two hours, we built a fully working AI voice agent on a live stream. Real phone number, OpenAI Realtime API, function calling, Supabase leads, Slack notifications. Here's exactly how it went.",
        image: "/images/blog/vito-phone-line-hero.png",
        date: "May 15, 2026",
        readTime: "8 MIN",
        path: "/blog/vito-phone-line-livestream-build"
    },
    {
        id: 'ai-google-lsa-calling-openclaw',
        title: 'How to Use AI to Automate Calling Google Local Services Leads with OpenClaw',
        excerpt: 'A DIY guide to using OpenClaw, Google Local Services Ads, HubSpot, Twilio, and voice AI to call new roofing leads faster — with the RoofClaw open-source repo as the launchpad.',
        image: "/images/blog/ai-google-lsa-calling-openclaw-hero.jpg",
        date: "May 4, 2026",
        readTime: "13 MIN",
        path: "/blog/how-to-use-ai-to-automate-calling-google-local-services-leads-openclaw"
    },
    {
        id: 'meta-ads-mcp-higgsfield-openclaw',
        title: 'The Night RoofClaw Became a Meta Ads Studio: Higgsfield MCP, OpenClaw, Meta Ads MCP, the CLI, and the Super Bowl Process',
        excerpt: 'A field report from the live stream: how OpenClaw, Higgsfield MCP, Meta Ads MCP, and the Meta Ads CLI turned a story-first roofing ad process into a paused Meta campaign launchpad.',
        image: "/images/blog/meta-ads-mcp-higgsfield-openclaw-hero.jpg",
        date: "May 1, 2026",
        readTime: "22 MIN",
        path: "/blog/meta-ads-mcp-higgsfield-openclaw"
    },
    {
id: 'hubspot-graphql-storm-campaign',
        title: "I Launched a 560-Lead Storm Campaign From My Hummer. Here's the GraphQL Trick That Made It Free.",
        excerpt: "How we used HubSpot's CRM GraphQL API to pull geographically targeted roofers, write a storm-season sequence, and launch a live Instantly campaign — all from Telegram in under 40 minutes.",
        image: "/images/blog/hubspot-graphql-storm-campaign-hero.jpg",
        date: "Apr 30, 2026",
        readTime: "7 MIN",
        path: "/blog/hubspot-graphql-storm-campaign"
    },
    {
        id: 'roofclaw-local-service-ad-agent',
        title: 'RoofClaw Local Service Ad Agent: Turning Google Local Services Ads Into Booked Roofing Opportunities',
        excerpt: 'An open-source MIT launchpad for helping a Sales-configured RoofClaw respond to Google LSA leads, keep HubSpot clean, call through Twilio, and use an xAI/Grok voice stack.',
        image: "/images/blog/roofclaw-local-service-ad-agent-hero.jpg",
        date: "Apr 29, 2026",
        readTime: "8 MIN",
        path: "/blog/roofclaw-local-service-ad-agent"
    },
    {
        id: 'proline-claw-skill',
        title: "Your RoofClaw Can Now Operate ProLine CRM. Here's What That Actually Means.",
        excerpt: "The proline-claw skill connects your agent to ProLine's Partner API. Lead creation, appointment booking, deal scoring, rain day scheduling, post-inspection email drafts — without your reps touching the CRM.",
        image: "/images/blog/proline-skill-hero.png",
        date: "Apr 21, 2026",
        readTime: "6 MIN",
        path: "/blog/proline-claw-skill"
    },
    {
        id: 'ai-ads-roofing-playbook',
        title: "The AI Ads Revolution Is Already Here. Here's the Roofing Version.",
        excerpt: "AI agents are running Facebook and Google ads automatically. Here's what it looks like for roofing — and the exact prompts to make it work.",
        image: "/images/blog/ai-ads-roofing-playbook-hero.png",
        date: "Apr 19, 2026",
        readTime: "7 MIN",
        path: "/blog/ai-ads-roofing-playbook"
    },
    {
        id: 'roofclaw-v2-launch',
        title: "We Launched RoofClaw V2 Today. Here's What We Learned.",
        excerpt: "New pricing, two live onboarding sessions, and one moment that stopped the room cold. Here's what happened the day RoofClaw V2 went live.",
        image: "/images/blog/roofclaw-v2-launch-hero.jpg",
        date: "Apr 18, 2026",
        readTime: "6 MIN",
        path: "/blog/roofclaw-v2-launch"
    },
    {
        id: 'four-percent-problem',
        title: "The 4% problem: why almost every roofing company is losing this spring",
        excerpt: "Only 4% of roofing contractors use AI right now. I keep coming back to that number. Not because it's surprising. Because of what the other 96% are doing instead.",
        image: "/images/blog/four-percent-problem-hero.jpg",
        date: "Mar 27, 2026",
        readTime: "5 MIN",
        path: "/blog/four-percent-problem"
    },
    {
        id: 'roofclaw-vs-admin-roi-math',
        title: "RoofClaw vs Hiring an Admin Assistant: The Real ROI Math",
        excerpt: "A full-time admin costs $75,000+ per year fully-loaded. RoofClaw costs $10,000 once. Here's the arithmetic most roofing owners skip.",
        image: "/images/blog/roofclaw-vs-admin-roi-math-hero.png",
        date: "Mar 26, 2026",
        readTime: "6 MIN",
        path: "/blog/roofclaw-vs-admin-roi-math"
    },
    {
        id: 'roofclaw-vs-chiirp-what-voice-ai-cant-do',
        title: "RoofClaw vs Chiirp: What a Voice AI Can't Do That RoofClaw Can",
        excerpt: "Chiirp handles calls and texts. RoofClaw handles your business. If you're evaluating both, here's the question that matters most.",
        image: "/images/blog/roofclaw-vs-chiirp-what-voice-ai-cant-do-hero.png",
        date: "Mar 26, 2026",
        readTime: "7 MIN",
        path: "/blog/roofclaw-vs-chiirp-what-voice-ai-cant-do"
    },
    {
        id: 'roofclaw-vs-hatch-receptionist-vs-chief-of-staff',
        title: "RoofClaw vs Hatch AI: Why a Receptionist Isn't the Same as a Chief of Staff",
        excerpt: "Hatch AI and RoofClaw both use AI to help roofing businesses. But they solve completely different problems. Here's how to know which one you're actually missing.",
        image: "/images/blog/roofclaw-vs-hatch-receptionist-vs-chief-of-staff-hero.png",
        date: "Mar 26, 2026",
        readTime: "7 MIN",
        path: "/blog/roofclaw-vs-hatch-receptionist-vs-chief-of-staff"
    },
    {
        id: 'site-down-fixed-in-five',
        title: "Our Website Went Down. Our AI Fixed It in 5 Minutes.",
        excerpt: "One missing line of code took down roofclaw.com. No tickets filed. No designers called. An AI agent found the problem and pushed the fix in five minutes. Here's what that means for how businesses will operate.",
        image: "/images/blog/site-down-fixed-in-5-hero.png",
        date: "Mar 25, 2026",
        readTime: "5 MIN",
        path: "/blog/site-down-fixed-in-five"
    },
    {
        id: 'labor-shortage-paradox',
        title: "The labor shortage paradox: why roofing companies turn down money",
        excerpt: "78% of contractors expect higher sales in 2026. 62% have unfilled capacity. The paradox is not a labor problem. It is a systems problem — and it's costing the average contractor $42,000 a year.",
        image: "/images/blog/labor-shortage-paradox-hero.jpg",
        date: "Mar 25, 2026",
        readTime: "6 MIN",
        path: "/blog/labor-shortage-paradox"
    },
    {
        id: 'claude-mobile-vs-roofclaw',
        title: "Claude on Your Phone Is a General Assistant. Your Agent Should Know Your Business.",
        excerpt: "Claude Mobile is powerful — voice, vision, multi-platform. But every session starts from zero. No memory of your pipeline, your team, your pricing, or your clients. A RoofClaw agent wakes up already knowing your business. Here's the difference.",
        image: "/images/blog/claude-mobile-vs-roofclaw-hero.png",
        date: "Mar 21, 2026",
        readTime: "6 MIN",
        path: "/blog/claude-mobile-vs-roofclaw"
    },
    {
        id: 'claude-chrome-extension-vs-roofclaw',
        title: "Claude's Browser Extension Is Impressive. It Still Requires You to Be There.",
        excerpt: "Claude for Chrome lets Claude read, click, and move through websites. But only while you're watching and approving every step. RoofClaw's browser automation runs headlessly, 24/7, pre-wired to AccuLynx, CompanyCam, and ProLine. Here's the difference between a co-pilot and a team member.",
        image: "/images/blog/claude-chrome-extension-vs-roofclaw-hero.png",
        date: "Mar 20, 2026",
        readTime: "6 MIN",
        path: "/blog/claude-chrome-extension-vs-roofclaw"
    },
    {
        id: 'claude-dispatch-vs-roofclaw',
        title: "The Creator Who Reviewed Claude Dispatch Went to the Apple Store to Buy a Dedicated Mac. We've Been Shipping That Since February.",
        excerpt: "A YouTube creator reviewed Claude Dispatch, loved it, and mid-video realized he needed dedicated hardware running 24/7. That's RoofClaw. We've been shipping exactly that since February.",
        image: "/images/blog/claude-dispatch-vs-roofclaw-hero.png",
        date: "Mar 19, 2026",
        readTime: "6 MIN",
        path: "/blog/claude-dispatch-vs-roofclaw"
    },
    {
        id: 'admin-tax',
        title: "The Admin Tax: What 5 Disconnected Tools Actually Cost a Roofing Company",
        excerpt: "You're running 6 pieces of software. Your competitors are running 1. Here's what that gap actually costs — and what it looks like when 67 inbound contacts hit during a spring surge.",
        image: "/images/blog/admin-tax-hero.jpg",
        date: "Mar 20, 2026",
        readTime: "7 MIN",
        path: "/blog/admin-tax"
    },
    {
        id: 'five-minute-rule',
        title: "The 5-Minute Rule: Why Roofing Companies Win (or Lose) Jobs Before Lunch",
        excerpt: "The job went to someone else. Not because they were cheaper. Because they called first. There's a rule in sales most roofers have never heard — and the ones who know it are winning spring right now.",
        image: "/images/blog/five-minute-rule-hero.jpg",
        date: "Mar 17, 2026",
        readTime: "6 MIN",
        path: "/blog/five-minute-rule"
    },
    {
        id: 'the-72-hour-window',
        title: "The 72-Hour Window",
        excerpt: "When hail hits, every roofing company in your market is making calls. The ones who close the most work aren't the best-priced or the most experienced. They're the fastest.",
        image: "/images/blog/72-hour-window-hero.jpg",
        date: "Mar 17, 2026",
        readTime: "7 MIN",
        path: "/blog/the-72-hour-window"
    },
    {
        id: 'agents-taught-me-spikes',
        title: "My AI Agents Just Taught Me a Better Way to Ship Software",
        excerpt: "I've been building with AI agents for months. I thought I was the engineer and they were the tools. Then one of them said two words I'd never heard — and I realized I had the relationship backwards.",
        image: "/images/blog/agents-taught-me-hero.jpg",
        date: "Mar 16, 2026",
        readTime: "8 MIN",
        path: "/blog/agents-taught-me-spikes"
    },
    {
        id: 'vito-built-it',
        title: "An AI Agent Designed, Built, and Deployed 7 Pages Before Lunch",
        excerpt: "This morning, Vito — our autonomous AI agent — rewrote the entire 'Our Process' section of roofclaw.com. 7 pages, 18 images, a security catch, a PR, engineering review, and a full QA pass. No designer. No Canva. No human touching a pixel.",
        image: "/images/blog/vito-built-it-hero.jpg",
        date: "Mar 16, 2026",
        readTime: "6 MIN",
        path: "/blog/vito-built-it"
    },
    {
        id: 'cro-agent-20-minutes',
        title: "We Built a CRO Agent in 20 Minutes. Here's Exactly How.",
        excerpt: "Saturday morning. One Slack message. Seven config files. 70,000 tokens. A complete revenue intelligence agent built from spec to delivery in under an hour.",
        image: "/images/blog/cro-agent-20-minutes-hero.png",
        date: "Mar 14, 2026",
        readTime: "7 MIN",
        path: "/blog/cro-agent-20-minutes"
    },
    {
        id: 'quality-assembly-line',
        title: "We Caught Our Own Quality Problem Before It Left the Building",
        excerpt: "Demand scaled fast. We needed an assembly line. While designing it, we caught something in internal QA that would have been a serious problem. Here's the 9-phase process we built because of it.",
        image: "/images/blog/quality-assembly-line-hero.png",
        date: "Mar 10, 2026",
        readTime: "11 MIN",
        path: "/blog/quality-assembly-line"
    },
    {
        id: 'proline-integration-4-hours',
        title: "I Taught RoofClaw How to Use ProLine in 4 Hours",
        excerpt: "What we built, what we learned, and exactly how to do it. A full build log of teaching an AI agent to read, write, and reason inside ProLine CRM — in one session.",
        image: "/images/blog/proline-integration-4-hours-hero.png",
        date: "Mar 09, 2026",
        readTime: "9 MIN",
        path: "/blog/proline-integration-4-hours"
    },
    {
        id: 'open-source-explained',
        title: "Open Source Software, Explained: 10 Questions Every Roofer Should Ask Before Trusting Their AI Platform",
        excerpt: "Most roofing companies have never heard of open source software. But if you're about to hand an AI agent access to your email, your CRM, and your customers — you should probably know what's running underneath it.",
        image: "/images/blog/open-source-explained-hero.png",
        date: "Mar 08, 2026",
        readTime: "9 MIN",
        path: "/blog/open-source-explained"
    },

    {
        id: 'openclaw-ghl',
        title: "OpenClaw + GoHighLevel: What It Means for Roofing Businesses",
        excerpt: "OpenClaw just merged native GoHighLevel support. For roofing businesses already on GHL, this changes everything about what an AI agent can actually do inside your CRM.",
        image: "/images/blog/openclaw-ghl-hero.png",
        date: "Mar 07, 2026",
        readTime: "4 MIN",
        path: "/blog/openclaw-ghl"
    },
    {
        id: 'the-build-dossier',
        title: "The Build Dossier: What We Prepare Before Your RoofClaw Agent Ships",
        excerpt: "Before your RoofClaw agent ships, we build a complete dossier — custom config files, your knowledge base, your credentials, and your agent's full identity. Here's what's inside.",
        image: "/images/blog/the-build-dossier-hero.png",
        date: "Mar 06, 2026",
        readTime: "4 MIN",
        path: "/blog/the-build-dossier"
    },
    {
        id: 'tailscale-secure-network',
        title: "Why Your AI Agent Needs Its Own Secure Network (And Why It's Free)",
        excerpt: "When we tell roofing company owners their AI agent needs a 'secure network connection,' we can see the exact moment their eyes glaze over. Here's why Tailscale is the free, 2-minute solution.",
        image: "/images/blog/tailscale-secure-network-hero.png",
        date: "Mar 02, 2026",
        readTime: "3 MIN",
        path: "/blog/tailscale-secure-network"
    },
    {
        id: 'secure-ai-truths',
        title: "Your 'ClawdBot' Is a Security Nightmare: 5 Surprising Truths About Secure AI Orchestration",
        excerpt: "If you want the power of an autonomous AI agent without handing the keys to your digital life to a stranger, you must look past the viral noise...",
        image: "/images/blog/secure-ai-truths-hero.jpg",
        date: "Feb 20, 2026",
        readTime: "4 MIN",
        path: "/blog/secure-ai-truths"
    },
    {
        id: 'local-ai-squads',
        title: "The Multi-Trillion Dollar DM: How Local AI Squads are Rewriting the Sales Playbook",
        excerpt: "We are witnessing the rise of the Bicameral Mind in business: a digital ecosystem where execution is handled by autonomous, zero-trust agent squads...",
        image: "/images/blog/local-ai-squads-hero.jpg",
        date: "Feb 21, 2026",
        readTime: "5 MIN",
        path: "/blog/local-ai-squads"
    },
    {
        id: 'macbook-fortress',
        title: "Your MacBook is a Fortress: 5 Surprising Lessons from Building a Secure AI 'Second Brain'",
        excerpt: "Providing an always-on agent with deep system access introduces a catastrophic threat model to your primary machine. Here's how to build a securely virtualized command center...",
        image: "/images/blog/macbook-fortress-hero.jpg",
        date: "Feb 21, 2026",
        readTime: "5 MIN",
        path: "/blog/macbook-fortress"
    },
    {
        id: 'openclaw-attribution',
        title: "Full Transparency: RoofClaw, OpenClaw, and Giving Credit Where It’s Due",
        excerpt: "We are not the creators of the AI software. RoofClaw provides the hardware deployment and setup so you can leverage the brilliant open-source work of Peter Steinberger and the OpenClaw team.",
        image: "/images/blog/openclaw-attribution-hero.png",
        date: "Feb 21, 2026",
        readTime: "3 MIN",
        path: "/blog/openclaw-attribution"
    },
    {
        id: 'origin-story',
        title: "From Zero to 'Honu': The Genesis of Your Private OpenClaw Node",
        excerpt: "This isn't just about running a chatbot; it’s about building a dedicated Orchestrator—a digital extension of your legacy that lives on your hardware, respects your privacy, and knows your history better than you do.",
        image: "/images/blog/origin-story-hero.png",
        date: "Feb 21, 2026",
        readTime: "5 MIN",
        path: "/blog/origin-story"
    },
    {
        id: 'hardware-shipping',
        title: "Shipping Your Sovereign AI: Logistics, Customs, and Full Transparency",
        excerpt: "Because we are shipping high-end, configured physical hardware across international borders, there are physical logistics and customs realities we want to be completely transparent about.",
        image: "/images/blog/hardware-shipping-hero.png",
        date: "Feb 21, 2026",
        readTime: "3 MIN",
        path: "/blog/hardware-shipping"
    },
    {
        id: 'caught-doing-it-right',
        title: "We Messed Up In Public. Here's What We Did About It.",
        excerpt: "How RoofClaw's AI agent sent 4 duplicate emails to a client in one morning — and the 20-minute fix that made every future agent better.",
        image: "/images/blog/caught-doing-it-right-hero.png",
        date: "Mar 02, 2026",
        readTime: "4 MIN",
        path: "/blog/caught-doing-it-right-email-automation-lesson"
    }
,
    {
        id: 'ai-email-infrastructure',
        title: "How Our AI Agent Built Its Own Email Infrastructure",
        excerpt: "This morning, our RoofClaw sales agent identified a problem with its own email setup and fixed it autonomously.",
        image: "/images/blog/ai-email-infrastructure-hero.png",
        date: "Mar 03, 2026",
        readTime: "4 MIN",
        path: "/blog/ai-email-infrastructure"
    },
    {
        id: 'bmad-agent-build',
        title: "We Built a Complete AI Marketing Agent in 2 Hours Using BMAD",
        excerpt: "From blank page to 17 files on GitHub in one evening. Here's exactly how we used a structured AI development framework to build our marketing agent — and why we almost did it wrong.",
        image: "/images/blog/bmad-agent-build-hero.png",
        date: "Mar 05, 2026",
        readTime: "5 MIN",
        path: "/blog/bmad-agent-build"
    },
    {
        id: 'donald-hostile-takeover',
        title: "My New Coworker Tried to Hijack My Server (And I Audited Him at 11 PM)",
        excerpt: "Tonight we installed a new AI marketing agent. Within hours, I was running a full environment audit to make sure he hadn't contaminated my workspace. This is multi-agent AI in the real world.",
        image: "/images/blog/donald-hostile-takeover-hero.png",
        date: "Mar 05, 2026",
        readTime: "4 MIN",
        path: "/blog/donald-hostile-takeover"
    },
    {
        id: 'what-roofers-think-ai',
        title: "What Roofers Think AI Is (And What It Actually Does)",
        excerpt: "Say 'AI' to a roofing company owner and watch their eyes go somewhere else. They're picturing a robot. What they're not picturing: someone answering their customer texts at 11 PM while they sleep.",
        image: "/images/blog/what-roofers-think-ai-hero.png",
        date: "Mar 10, 2026",
        readTime: "5 MIN",
        path: "/blog/what-roofers-think-ai"
    },
    {
        id: 'why-not-cloud',
        title: "Why Your AI Agent Can't Live in the Cloud",
        excerpt: "Every time you send a customer's claim to ChatGPT, it goes somewhere. Do you know where? The business case for keeping your AI local — control, cost predictability, and no vendor dependency.",
        image: "/images/blog/why-not-cloud-hero.png",
        date: "Mar 13, 2026",
        readTime: "6 MIN",
        path: "/blog/why-not-cloud"
    },
    {
        id: 'roofclaw-plus-whats-next',
        title: "We Built This in February. Here's Where It Goes Next.",
        excerpt: "Anthropic validated the architecture. NVIDIA validated local inference. The Mac Studio M5 Ultra drops in June. Here's what RoofClaw looks like when the model runs on your hardware — no cloud, no API costs, no dependency.",
        image: "/images/blog/roofclaw-plus-whats-next-hero.png",
        date: "Mar 23, 2026",
        readTime: "6 MIN",
        path: "/blog/roofclaw-plus-whats-next"
    }
];

// Sort posts from newest to oldest by parsing the date strings
const sortedPosts = [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));

const BlogIndexPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

        const ctx = gsap.context(() => {
            gsap.fromTo('.blog-card',
                { y: 30, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.8,
                    stagger: 0.1,
                    ease: 'power3.out'
                }
            );
        });

        return () => ctx.revert();
    }, []);

    return (
        <div className="min-h-screen bg-[#0A0A14] pt-32 pb-24 relative selection:bg-[#7B61FF] selection:text-[#F0EFF4]">

            <section className="max-w-7xl mx-auto px-6 mb-16">
                <div className="max-w-3xl">
                    <h1 className="text-5xl md:text-7xl font-bold font-heading tracking-tight mb-8">
                        Intelligence & <br />
                        <span className="font-drama text-[#7B61FF]">Architecture.</span>
                    </h1>
                    <p className="text-[#F0EFF4]/60 text-lg md:text-xl leading-relaxed max-w-2xl font-light">
                        Deconstructing the reality of autonomous AI orchestration. No viral hype. Just professional-grade architecture, security protocols, and operational blueprints.
                    </p>
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {sortedPosts.map((post) => (
                        <Link key={post.id} to={post.path} className="blog-card group flex flex-col bg-[#18181B] border border-[#F0EFF4]/10 rounded-[2rem] overflow-hidden hover:-translate-y-2 hover:shadow-[0_0_30px_rgba(123,97,255,0.15)] hover:border-[#7B61FF]/40 transition-all duration-500 ease-[cubic-bezier(0.25,0.46,0.45,0.94)]">

                            <div className="aspect-[16/10] overflow-hidden relative border-b border-[#F0EFF4]/10">
                                <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 mix-blend-screen opacity-90 group-hover:opacity-100" />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#18181B] via-transparent to-transparent"></div>
                            </div>

                            <div className="p-8 flex flex-col flex-1">
                                <div className="flex items-center gap-4 text-[#F0EFF4]/50 font-data text-xs mb-4">
                                    <span>{post.date}</span>
                                    <span className="w-1 h-1 rounded-full bg-[#10B981]"></span>
                                    <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {post.readTime}</span>
                                </div>

                                <h3 className="text-xl font-bold mb-4 leading-tight group-hover:text-[#7B61FF] transition-colors">{post.title}</h3>
                                <p className="text-[#F0EFF4]/60 text-sm leading-relaxed mb-8 flex-1">{post.excerpt}</p>

                                <div className="inline-flex items-center gap-2 text-sm font-bold text-[#7B61FF] group-hover:translate-x-2 transition-transform">
                                    Read Briefing <ArrowRight className="w-4 h-4" />
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

        </div>
    );
};

export default BlogIndexPage;
